import { Component, inject } from '@angular/core';
import { PartnersState } from '../state/partners.state';
import { Observable } from 'rxjs';
import { B2BPartnerListResponse } from '@api/models/B2bService/Contract/B2bPartner/b-2-b-partner-list-response';
import { PartnersGridComponent } from './partners-grid/partners-grid.component';
import { AsyncPipe } from '@angular/common';
import { ContentWrapperModule } from '@ui/layout/content-wrapper/content-wrapper.module';
import { HeadlineModule } from '@ui/layout/headline/headline.module';
import { HeadlineWrapperModule } from '@ui/layout/headline-wrapper/headline-wrapper.module';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { PrivilegesModules } from '@core/privileges/privileges-modules';
import { OnlyViewMode } from '@core/privileges/only-view-mode';
import { StartWithUnit } from '@core/state/operators/start-with-unit';
import { getLoadingProp } from '@core/state/operators/start-with-loading';
import { PolymorpheusComponent } from '@tinkoff/ng-polymorpheus';
import { HeadlineButtonComponent } from '@ui/layout/headline-button/headline-button.component';
import { HeadlineButtonContext } from '@ui/layout/layout.model';
import { BtnLabels } from '@ui/models/btn.labels';
import { RxEffects } from '@rx-angular/state/effects';
import { RouteEntity } from '@core/router/route.entity';
import { DialogService } from '@ui/dialog-v2/dialog.service';
import { Router } from '@angular/router';
import { AbstractGridHandlers } from '@ui/base/abstract-grid/abstract-grid.component';


@Component({
    selector: 'users-partners',
    imports: [PartnersGridComponent, AsyncPipe, ContentWrapperModule, HeadlineModule, HeadlineWrapperModule, TranslatePipe],
    templateUrl: './partners.component.html',
    styleUrl: './partners.component.scss',
    providers: [RxEffects, PartnersState],
})
export class PartnersComponent {
    @OnlyViewMode([PrivilegesModules.AcmanUsers])
    public readonly readonlyMode$: Observable<boolean>;

    readonly #partnersState: PartnersState = inject(PartnersState);
    readonly #effects: RxEffects = inject(RxEffects);
    readonly #translate: TranslateService = inject(TranslateService);
    readonly #dialog: DialogService = inject(DialogService);
    readonly #router: Router = inject(Router);

    public readonly partners$: Observable<B2BPartnerListResponse[]> = this.#partnersState.partners$;
    public readonly loading$: Observable<boolean> = this.#partnersState.loading$.pipe(getLoadingProp(StartWithUnit.RequestPartners));

    public readonly content: PolymorpheusComponent<HeadlineButtonComponent> = new PolymorpheusComponent(HeadlineButtonComponent);
    public headlineButtonContext: HeadlineButtonContext;

    public readonly handlersGrid: AbstractGridHandlers = {
        handlerDeleteEntity: this.deletePartner.bind(this),
        handlerRowClick: (partner: B2BPartnerListResponse) => {
            this.#router.navigate([RouteEntity.Root, RouteEntity.Partners, String(partner.orgId)]);
        },
    };

    constructor() {
        this.#effects.register(
            this.#translate.get(BtnLabels.Add),
            (translate: string) =>
                (this.headlineButtonContext = {
                    text: translate,
                    onClick: this.navigateToAddPartner.bind(this),
                }),
        );
    }

    public deletePartner(orgId: number): void {
        this.#dialog.openConfirmPopup(
            this.#partnersState.deletePartner.bind(this.#partnersState, orgId),
            this.#partnersState.loading$.pipe(getLoadingProp(StartWithUnit.DeletePartner)),
        );
    }

    private navigateToAddPartner(): void {
        this.#router.navigate([RouteEntity.Root, RouteEntity.Partners, RouteEntity.Add]);
    }
}
